import script from "./businessList.vue?vue&type=script&lang=ts&setup=true"
export * from "./businessList.vue?vue&type=script&lang=ts&setup=true"

import "./businessList.vue?vue&type=style&index=0&id=b9fe2852&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9fe2852"]])

export default __exports__